import React from "react";

import { CloseOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { ISuggestion } from "types/suggestion";

type SuggestionBoxProps = {
    suggestion: ISuggestion;
    summaryMessage?: string;
    onDismiss: () => void;
    onUseSuggested?: () => void;
    onViewTransactions?: () => void;
};

const SuggestionBox: React.FC<SuggestionBoxProps> = ({
    suggestion,
    summaryMessage,
    onDismiss,
    onUseSuggested,
    onViewTransactions,
}) => {
    if (!suggestion?.supportingData?.transactions?.length || !suggestion.isSuggested) return null;

    return (
        <div className="new-questionnaire__suggestion-box" style={{ position: "relative" }}>
            <CloseOutlined
                onClick={onDismiss}
                style={{ position: "absolute", top: 12, right: 12, cursor: "pointer" }}
            />
            <div className="new-questionnaire__suggestion-header">💡 Suggestion</div>
            <div className="new-questionnaire__suggestion-content">
                <div
                    className="new-questionnaire__suggestion-text"
                    dangerouslySetInnerHTML={{
                        __html: summaryMessage ?? suggestion.suggestion ?? "",
                    }}
                />

                {(onUseSuggested || onViewTransactions) && (
                    <div className="new-questionnaire__suggestion-buttons-row">
                        {onUseSuggested && (
                            <Button type="primary" size="middle" onClick={onUseSuggested}>
                                Use Suggested
                            </Button>
                        )}
                        {onViewTransactions && (
                            <Button size="middle" onClick={onViewTransactions}>
                                View Transactions
                            </Button>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
};

export default SuggestionBox;
